export const NOTHING_TEXT = 'Мероприятия не проводятся';
export const PLURAL_DEFAULT = ['мероприятий', 'мероприятие', 'мероприятия', 'мероприятий'];
export const WAITING_TEXT = 'Проводится';
export const DONE_TEXT = 'Проведено';



// WEBPACK FOOTER //
// ./src/components/calendar/detail/const.ts